var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.planSource)?_c('plan',{attrs:{"plan-source":_vm.planSource,"plan-query":_vm.planQuery}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }